<template>
    <div class="row">
        <div class="col-12 mt-2">
            {{resource('JourneyBuilder_FilterSettings_SelectOperator')}}
        </div>
        <div class="col-8 mb-2">
            <input-group icon="fas fa-cog">
                <v-select class="form-control"
                    v-model="selectedOperator"
                    label="text"
                          
                    :options="availableOperators"
                    
                    :getOptionKey="opt => opt.value"
                    :disabled="!canWrite"
                    :clearable="false"
                >
                    <div slot="no-options" />
                </v-select>
            </input-group>
        </div>
        <div class="col-4 mb-2 d-flex align-items-center">
            <b>{{resource('JourneyBuilder_FilterSettings_Audience')}}</b>
        </div>
        <div class="col-12">
            {{resource('JourneyBuilder_FilterSettings_SelectCondition')}}
        </div>
        <div class="col-12">
            <input-group icon="fas fa-filter">
                <v-select class="form-control"
                          v-model="selectedCondition"
                          label="name"

                          :options="availableConditions"
                          
                          :disabled="!canWrite"
                          :clearable="false"
                >
                    <div slot="no-options" />
                </v-select>
            </input-group>
        </div>
    </div>
</template>

<script>

import {conditionOperatorTypesArray as conditionOperators} from "../../../../ConnectionSettings/condition-operator-types";

import resources from '../../../../../../Util/Mixins/resources';
import Dropdown from '../../../../../../Components/Inputs/Dropdown.vue';
import InputGroup from '../../../../../../Components/Inputs/InputGroup.vue';
import VSelect from 'vue-select';

export default {
    name: 'journey-filter-action',
    components: {
        Dropdown,
        InputGroup,
        VSelect
    },
    mixins: [
        resources
    ],
    created() {
        this.updateCondition();
        this.updateOperator();
    },
    updated(){
        this.selectedCondition = this.availableConditions.find(c => c.id === this.value.conditionId) || null;
    },
    methods: {
        updateCondition(){
            this.selectedCondition = this.availableConditions.find(c => c.id === this.value.conditionId);    
        },
        updateOperator(){
            this.selectedOperator = this.availableOperators.find(o => o.value === this.value.operator);
        }
    },
    computed: {
        availableOperators() {
            const vm = this;

            return conditionOperators.filter(
                (operator) => {
                    const condition = vm.availableConditions.find((condition) => condition.id === vm.value.conditionId);
                    return !condition ? [] : condition.operators.indexOf(operator.value) !== -1;
                });
        }
    },
    watch: {
        selectedCondition(value){
            this.updateOperator();
            this.$emit('set-condition', value ? value.id : undefined);
        },
        selectedOperator(value)
        {
            this.$emit('set-operator', value ? value.value : undefined);
        }
    },
    data() {
        return {
            selectedCondition: null,
            selectedOperator: null
        };
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        availableConditions: {
            type: Array,
            required: true
        },
        canWrite: {
            type: Boolean,
            default: false
        }
    }
};
</script>
